export default __webpack_public_path__ + "static/media/Group 8085_grey.da3c6f8e.svg";